module.exports = __webpack_public_path__ + "img/violet_116.8b355b5e.png";